module.exports = __webpack_public_path__ + "static/media/bluedart_color copy.7a0f3d61.jpg";